





















































import { Vue, Component, Prop, PropSync, Ref, Watch } from 'vue-property-decorator'
import { SlickList } from 'vue-slicksort'
import arrayCrdtSortNumber from 'src/assets/arrayCrdtSortNumber'
import ModalDialog from 'components/modals/Dialog.vue'
import SlidesEditorGridItem from 'components/presenter/item/topic/editor/SlidesEditorGridItem.vue'

@Component({
  components: {
    SlickList,
    ModalDialog,
    SlidesEditorGridItem
  }
})
export default class ItemTopicSlidesEditorGrid extends Vue {
  gridSlides: Json[] = []

  @Prop()
  readonly groups!: Json

  @Prop()
  readonly corrects!: Json

  @Prop()
  readonly reorder!: boolean

  @Prop()
  readonly editable!: boolean

  @Prop()
  readonly slides!: Json[]

  @PropSync('selectedSync')
  selected!: Set<Json> | null

  @Prop()
  readonly save!: (slides: Json[], name: string, value: any) => void

  @Ref()
  readonly selectActionsDialog!: ModalDialog

  get size () {
    return this.$q.screen.xs ? 'sm' : 'md'
  }

  get selectedIds () {
    return this.selected ? new Set([...this.selected].map(s => s.id)) : null
  }

  @Watch('slides', { immediate: true })
  selectedUpdate (slides: Json[]) {
    this.gridSlides = [...slides]
    if (this.selected) {
      const selected = new Set<Json>()
      const selectedIds = new Set<string>([...this.selected].map(s => s.id))
      for (let slide of this.gridSlides) {
        if (selectedIds.has(slide.id)) {
          selected.add(slide)
        }
      }
      this.selected = selected
    }
  }

  async slideMove ({ newIndex, oldIndex }: { newIndex: number, oldIndex: number }) {
    const slide = this.gridSlides[oldIndex]
    if (slide.meta?.masterSlide) {
      const masterSlide = slide.meta.masterSlide
      const masterSlidePages = masterSlide.meta?.pages || []
      const masterSlidePage = masterSlidePages[ slide.meta.masterSlidePageIndex ] || {}
      masterSlidePage.sort = arrayCrdtSortNumber(this.gridSlides, newIndex, oldIndex)
      await this.save([ masterSlide ], 'meta', masterSlide.meta)
    } else {
      await this.save([slide], 'sort', arrayCrdtSortNumber(this.gridSlides, newIndex, oldIndex))
    }
  }

  selectAll () {
    this.selectActionsDialog.hide()
    this.selected = new Set(this.gridSlides)
  }

  selectNone () {
    this.selectActionsDialog.hide()
    this.selected = new Set()
  }

  selectInverse () {
    this.selectActionsDialog.hide()
    const selected = new Set<Json>()
    for (let slide of this.gridSlides) {
      if (!this.selected?.has(slide)) {
        selected.add(slide)
      }
    }
    this.selected = selected
  }

  toggleSelect (slide: Json) {
    if (this.selected) {
      if (this.selected.has(slide)) {
        this.selected.delete(slide)
      } else {
        this.selected.add(slide)
      }
      this.selected = new Set(this.selected)
    }
  }
}
